import styled from '@emotion/styled'

import { color, colors, theme } from '../../Theme'
import Button from '../button/Button'

export const BaseCtaButton = styled(Button)`
  width: 100%;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  ${theme.text('normal', 'content', 'bold')};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const AiButton = styled(BaseCtaButton)`
  background: ${colors.purple20};
`

export const ActionButton = styled(BaseCtaButton)`
  background: ${color('primaryBlue')};
`

export const EscapeLink = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${color('primaryBlue')};
  background: ${color('white')};
  border: 1px solid ${color('grayLight')};
  border-radius: 4px;
  padding: 0;
  cursor: pointer;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  height: 62px;
  box-sizing: border-box;
  margin-top: 4px;
  ${theme.text('normal', 'content', 'bold')};
`
